import type { CurrencyFormatSettings } from '../../../../../types/Configuration';
import selectCurrencyFormat from './selectCurrencyFormat';
import { NO_BREAK_SPACE } from './unbreakableSpaces';

const DEFAULT_FORMAT = '{SYMBOL} {CODE}';

const formatCurrency = (
  currencyConfig: CurrencyFormatSettings | undefined,
  symbol: string,
  code: string,
  language: string,
) => {
  const currencySpecificFormat = selectCurrencyFormat(currencyConfig, code, language);

  const stringFormat = currencySpecificFormat?.stringFormat ?? currencyConfig?.stringFormat ?? DEFAULT_FORMAT;
  return stringFormat
    .replace('{SYMBOL}', symbol)
    .replace('{AMOUNT}', '')
    .replace('{CODE}', code)
    .replace(/ /g, NO_BREAK_SPACE);
};

export default formatCurrency;
